import Stack from "@mui/material/Stack";
import useScreenSize from "../../context/ScreenContext";
import { Theme } from "../../data/style/Theme";
import { SecondaryTitle } from "../../data/style/Style";

const DateInput = (props) => {
  const { mobileDevice } = useScreenSize();
  let { setValue, de, label } = props;
  let handleValueChange = (e) => setValue(e.target.value);

  return (
    <Stack width={"100%"} gap={1}>
      <SecondaryTitle sx={{ fontSize: "0.6rem !important" }}>
        {label}
      </SecondaryTitle>
      <input
        defaultValue={de}
        onChange={handleValueChange}
        style={{
          border: "1px solid",
          background: Theme.palette.card,
          borderColor: Theme.palette.borderLight,
          height: mobileDevice ? "30px" : "40px",
          paddingLeft: "5px",
          paddingRight: "5px",
          color: Theme.palette.text,
          fontFamily: "DM sans",
          textTransform: "uppercase",
          outline: "none",
          fontSize: "0.8rem",
          borderRadius: "12px",
        }}
        type="date"
      />
    </Stack>
  );
};

export default DateInput;
